function ioCallback(entries, observer) {
  entries.forEach((entry) => {
    const { target, isIntersecting } = entry;

    switch (target.tagName) {
      case 'IMG': {
        if (isIntersecting) {
          target.src = target.dataset.src;

          if (target.hasAttribute('data-srcset')) {
            target.srcset = target.dataset.srcset;
          }

          target.removeAttribute('defer');
        } else {
          target.setAttribute('defer', '');
        }
        break;
      }

      case 'VIDEO': {
        if (isIntersecting) {
          target.currentTime = 0;
          target.play();
          target.removeAttribute('defer');
        } else {
          target.pause();
          target.setAttribute('defer', '');
        }
        break;
      }

      default: {
        if (isIntersecting) {
          target.removeAttribute('defer');
        } else {
          target.setAttribute('defer', '');
        }
      }
    }
  });
}

const options = {
  rootMargin: "0% 0% 0% 0%",
  threshold: 0.50,
}


document.addEventListener('DOMContentLoaded', () => {
  const io = new IntersectionObserver(ioCallback, options);

  const bgVideos = document.querySelectorAll('.shopify-section.page-background video');

  bgVideos.forEach(videoEl => {
    videoEl.addEventListener('loadeddata', event => {
      videoEl.classList.remove('loading');
    });

    io.observe(videoEl);
  });
});
